export default __webpack_public_path__ + "static/media/Image1.6336ccbc.png";